import React, {PropsWithChildren} from 'react';
import {useSelector} from 'react-redux';
import {previewsLoaderSelector} from '../../store/selectors/presentation.selectors';
import Card from './common/Card';

interface GridCardProps {
    imgSrc?: string;
    onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
}

GridCard.defaultProps = {
    imgSrc: undefined,
    onClick: undefined,
};

function GridCard(props: PropsWithChildren<GridCardProps>): JSX.Element {
    const {imgSrc, children, onClick} = props;

    const previewsLoader = useSelector(previewsLoaderSelector);

    const getImgSrc = (): string => {
        if (!previewsLoader && imgSrc) return imgSrc;
        return '';
    };

    return (
        <Card
            modifiers={['grid']}
            header={
                <div className={`c-card__header_img u-pointer ${previewsLoader && 'is-loading'}`} onClick={onClick}>
                    <img src={getImgSrc()} alt="" />
                </div>
            }
        >
            {children}
        </Card>
    );
}

export default GridCard;
